<template>
  <span class="freight-table-tag" :class="`freight-table-tag--${variant}`">
    <slot />
  </span>
</template>

<script>
const VARIANTS = ['success', 'warning', 'info', 'neutral'];

export default {
  name: 'FreightTableTag',
  props: {
    variant: {
      type: String,
      default: 'neutral',
      validator: (value) => VARIANTS.indexOf(value) !== -1,
    },
  },
};
</script>

<style scoped lang="less">
@import '~@/shared/styles/variables.less';

.freight-table-tag {
  display: inline-flex;
  align-items: center;
  padding: 1px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;

  &--success {
    background-color: @color-tag-success-bg;
    color: @color-success;
  }

  &--warning {
    background-color: @color-tag-warning-bg;
    color: @color-tag-warning-text;
  }

  &--info {
    background-color: @color-tag-info-bg;
    color: @color-primary;
  }

  &--neutral {
    background-color: @color-bg-subtle;
    color: @color-text-medium;
  }
}
</style>
